module.exports = __webpack_public_path__ + "img/karin.c8b1696.png";